export const environment = {
  production: true
};



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/nostra-mufit-info-prod/workspace/src/environments/environment.ts